export default {
  chooseGame: "Game selection",
  chooseGym: "Gym selection",
  chooseMicrolearning: "Microlearning selection",
  learningPaths: "Courses",
  logOut: "Log out",
  support: "Support",
  termsOfUse: "Terms of Use",
  remainingCreditPercentage: "remaining credits",
  switchOrganization: "Switch organization",
  selectGroup: "Select group",
  profile: "Profile",
  history: "History",
  adminDashboard: "Admin dashboard",
  managerDashboard: "Manager dashboard",
  myPerformance: "My Performance",
  compactModePromptTitle: "Use compact mode?",
  compactModePromptDescription: "Your current browser zoom setting is causing the interface to appear cramped. Enabling compact mode will adjust the layout to fit better in the available space. You can turn this mode on or off later in the settings.",
  compactModeAccept: "Turn on compact mode",
  compactModeDecline: "Keep standard layout",
  enableCompactMode: "Turn on compact mode",
  disableCompactMode: "Turn off compact mode",
};
